// extracted by mini-css-extract-plugin
module.exports = {"splide":"MaterialDetailSlider_splide__IzUMr"};